import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum DocumentIconVariant {
  FILL = 'fill',
  LINE = 'LINE',
}
interface IDocumentIconProps extends IConDefaultType {
  variant?: DocumentIconVariant;
}

function DocumentIcon({
  className,
  size = 28,
  rotate,
  flip,
  color,
  variant = DocumentIconVariant.FILL,
}: IDocumentIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === DocumentIconVariant.FILL && (
        <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19.272 19.2528C19.4762 19.0936 19.6614 18.9084 20.0317 18.5381L24.6487 13.9211C24.7603 13.8095 24.7092 13.6172 24.5601 13.5655C24.0151 13.3764 23.3062 13.0214 22.643 12.3583C21.9799 11.6951 21.6249 10.9862 21.4358 10.4412C21.3841 10.2921 21.1918 10.241 21.0802 10.3526L16.4632 14.9696L16.4632 14.9696C16.0929 15.3399 15.9077 15.5251 15.7485 15.7293C15.5606 15.9701 15.3996 16.2307 15.2682 16.5064C15.1568 16.7402 15.0739 16.9886 14.9083 17.4855L14.6943 18.1275L14.354 19.1484L14.0349 20.1056C13.9534 20.3502 14.0171 20.6197 14.1993 20.802C14.3816 20.9842 14.6512 21.0479 14.8957 20.9664L15.8529 20.6473L16.8738 20.307L17.5158 20.093L17.5158 20.093C18.0127 19.9274 18.2611 19.8445 18.4949 19.7331C18.7706 19.6017 19.0312 19.4407 19.272 19.2528Z"
            fill={color || theme.color.icon.icon_1}
          />
          <path
            d="M26.0943 12.4755C27.0797 11.4901 27.0797 9.89244 26.0943 8.90703C25.1089 7.92162 23.5112 7.92162 22.5258 8.90703L22.3774 9.05546C22.2341 9.19869 22.1692 9.39876 22.205 9.59813C22.2275 9.72356 22.2692 9.90692 22.3452 10.1257C22.497 10.5633 22.7837 11.1377 23.3236 11.6777C23.8636 12.2176 24.438 12.5043 24.8756 12.6561C25.0944 12.7321 25.2777 12.7738 25.4032 12.7963C25.6025 12.8321 25.8026 12.7672 25.9458 12.6239L26.0943 12.4755Z"
            fill={color || theme.color.icon.icon_1}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.86684 3.69887C3.5 5.0657 3.5 7.26559 3.5 11.6654V16.332C3.5 20.7318 3.5 22.9317 4.86684 24.2985C6.23367 25.6654 8.43356 25.6654 12.8333 25.6654H15.1667C19.5664 25.6654 21.7663 25.6654 23.1332 24.2985C24.4781 22.9536 24.4996 20.8022 24.5 16.5421L21.212 19.8301C20.8973 20.1451 20.6395 20.4031 20.3484 20.6301C20.0073 20.8961 19.6383 21.1242 19.2478 21.3103C18.9145 21.4691 18.5685 21.5843 18.1461 21.725L15.4491 22.624C14.5758 22.9151 13.6129 22.6878 12.9619 22.0368C12.311 21.3859 12.0837 20.423 12.3748 19.5496L12.6939 18.5924L13.2482 16.9295L13.2737 16.8527C13.4144 16.4303 13.5296 16.0842 13.6884 15.751C13.8745 15.3605 14.1026 14.9914 14.3686 14.6504C14.5957 14.3593 14.8537 14.1015 15.1686 13.7867L19.8428 9.11256L21.14 7.81542L21.2884 7.66699C22.123 6.83235 23.217 6.41514 24.311 6.41537C24.1345 5.21306 23.7931 4.35885 23.1332 3.69887C21.7663 2.33203 19.5664 2.33203 15.1667 2.33203H12.8333C8.43356 2.33203 6.23367 2.33203 4.86684 3.69887ZM8.45833 10.4987C8.45833 10.0154 8.85008 9.6237 9.33333 9.6237H16.9167C17.3999 9.6237 17.7917 10.0154 17.7917 10.4987C17.7917 10.9819 17.3999 11.3737 16.9167 11.3737H9.33333C8.85008 11.3737 8.45833 10.9819 8.45833 10.4987ZM8.45833 15.1654C8.45833 14.6821 8.85008 14.2904 9.33333 14.2904H12.25C12.7332 14.2904 13.125 14.6821 13.125 15.1654C13.125 15.6486 12.7332 16.0404 12.25 16.0404H9.33333C8.85008 16.0404 8.45833 15.6486 8.45833 15.1654ZM8.45833 19.832C8.45833 19.3488 8.85008 18.957 9.33333 18.957H11.0833C11.5666 18.957 11.9583 19.3488 11.9583 19.832C11.9583 20.3153 11.5666 20.707 11.0833 20.707H9.33333C8.85008 20.707 8.45833 20.3153 8.45833 19.832Z"
            fill={color || theme.color.icon.icon_1}
          />
        </svg>
      )}
      {variant === DocumentIconVariant.LINE && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19.18 8.03933L19.6435 7.57589C20.4113 6.80804 21.6563 6.80804 22.4241 7.57589C23.192 8.34374 23.192 9.58868 22.4241 10.3565L21.9607 10.82M19.18 8.03933C19.18 8.03933 19.238 9.02414 20.1069 9.89309C20.9759 10.762 21.9607 10.82 21.9607 10.82M19.18 8.03933L14.9194 12.2999C14.6308 12.5885 14.4865 12.7328 14.3624 12.8919C14.2161 13.0796 14.0906 13.2827 13.9882 13.4975C13.9014 13.6797 13.8368 13.8732 13.7078 14.2604L13.2946 15.5L13.1609 15.901M21.9607 10.82L17.7001 15.0806C17.4115 15.3692 17.2672 15.5135 17.1081 15.6376C16.9204 15.7839 16.7173 15.9094 16.5025 16.0118C16.3203 16.0986 16.1268 16.1632 15.7396 16.2922L14.5 16.7054L14.099 16.8391M14.099 16.8391L13.6979 16.9728C13.5074 17.0363 13.2973 16.9867 13.1553 16.8447C13.0133 16.7027 12.9637 16.4926 13.0272 16.3021L13.1609 15.901M14.099 16.8391L13.1609 15.901"
            stroke={color || theme.color.icon.icon_1}
            strokeWidth="2"
          />
          <path d="M8 13H10.5" stroke={color || theme.color.icon.icon_1} strokeWidth="2" strokeLinecap="round" />
          <path d="M8 9H14.5" stroke={color || theme.color.icon.icon_1} strokeWidth="2" strokeLinecap="round" />
          <path d="M8 17H9.5" stroke={color || theme.color.icon.icon_1} strokeWidth="2" strokeLinecap="round" />
          <path
            d="M19.8284 3.17157C18.6569 2 16.7712 2 13 2H11C7.22876 2 5.34315 2 4.17157 3.17157C3 4.34315 3 6.22876 3 10V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C20.7715 19.8853 20.9554 18.4796 20.9913 16"
            stroke={color || theme.color.icon.icon_1}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      )}
    </i>
  );
}

export default DocumentIcon;
